/**
 * Upload-related constants for PropWise
 */

export const FILE_SIZE = {
  /** Maximum per-file upload size in bytes (20MB) */
  MAX_UPLOAD_BYTES: 20 * 1024 * 1024,
  /** Maximum per-file upload size in megabytes */
  MAX_UPLOAD_MB: 20,
  /** Maximum aggregate upload size across all PDFs in one report (50MB) */
  MAX_TOTAL_UPLOAD_BYTES: 50 * 1024 * 1024,
  /** Maximum aggregate upload size in megabytes */
  MAX_TOTAL_UPLOAD_MB: 50,
  /** Maximum number of PDFs allowed in a single report */
  MAX_FILES_PER_REPORT: 10,
} as const;

export const FILE_TYPES = {
  /** Allowed MIME types for file uploads */
  ALLOWED_MIME_TYPES: ['application/pdf'] as const,
  /** PDF MIME type */
  PDF: 'application/pdf',
} as const;
